module.exports = __webpack_public_path__ + "static/media/signage-indoor-img36.03aaf6f1.jpg";